import userApi from "@/api/user";

interface UserState {
    isLogged: boolean
    isLoginError: boolean
    login: string | null
    token: string | null
    error: string | null
    userInfo: UserInfo | null
}

interface UserDetails {
    login: string,
    password: string
}

interface UserInfo {
    sub: string,
    name: string,
    preferred_username: string,
    email: string,
    role: string[]
}

const state: UserState = {
    isLogged: false,
    isLoginError: false,
    login: null,
    token: null,
    error: null,
    userInfo: null
};

const getters = {
    getIsLogged(state: UserState, getters: any) {
        return state.isLogged;
    },
    getIsLoginError(state: UserState, getters: any) {
        return state.isLoginError;
    },
    getLogin(state: UserState, getters: any) {
        return state.login;
    },
    getToken(state: UserState, getters: any) {
        return state.token;
    },
    getUserInfo(state: UserState, getters: any) {
        return state.userInfo;
    }
};

const actions = {
    loginRequest: async (
        context: any,
        payload: any
    ) => {
        try {
            const requestLogin = await userApi.authenticate(payload);

            if (requestLogin &&
                requestLogin.data &&
                requestLogin.data.status) {

                const {status, token} = requestLogin.data;
                
                if (status.toLowerCase() === "error") {
                    context.commit('loginError');
                } else {
                    context.commit('loginSuccess', token);

                    try {
                        const requestUserInfo = await userApi.getUserInfo();
                        context.commit("userInfo", requestUserInfo.data);
                    } catch (err) {
                        console.log('Error in: ', err);
                    }
                }
            }


        } catch (err) {
            context.commit('loginError');
        }
    },
    logout: async (context: any, payload: any) => {
        try {
            context.commit('logout')
        } catch (err) {
            context.commit('loginError');
        }
    },
    clear: (context: any) => {
        context.commit('logout')
    }
};

const mutations = {
    loginSuccess: (state: UserState, token: string) => {
        state.error = null
        state.token = token
        state.isLogged = true,
        state.isLoginError = false;
    },
    loginError: (state: UserState, error: string) => {
        state.error = error;
        state.isLoginError = true;
        state.token = null;
        state.isLogged = false;
    },
    logout: (state: UserState) => {
        state.error = null;
        state.token = null;
        state.login = null;
        state.isLogged = false;
        state.isLoginError = false;
    },
    userInfo: (state: UserState, userInfo: any) => {
        state.userInfo = userInfo;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
